import { PaginatedStockItems, StockItemParams } from "@/types/stock-item";
import { apiUrl } from "@/utils/url";
import { HttpClient } from "../HttpClient";
import { IStockService } from "./IStockService";

export class StockService implements IStockService {
  private readonly http: HttpClient;

  constructor() {
    this.http = new HttpClient({
      baseURL: apiUrl,
    });
  }

  getAvailableStock(
    params: StockItemParams,
    signal?: AbortSignal,
  ): Promise<PaginatedStockItems> {
    const queryParams = Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    return this.http.get<PaginatedStockItems>(
      `/stock/available-stock?${queryParams}`,
      { signal, timeout: 60000 },
    );
  }
}
